import React from 'react';

import './FatLevelSelector.css';
import FatLevelOption from './FatLevelOption';

type Props = {
  fatLevel: 'low' | 'medium' | 'high',
  updateFatLevel: () => void,
};

const FatLevelSelector = ({fatLevel, updateFatLevel}: Props) => {

  return (
    <>
    <h4 className="fat-level-title">Nível de gordura</h4>
    <div className="fat-level-selector-container">
      <FatLevelOption
        optionTile="high"
        selectedFatLevel={fatLevel}
        clickHandler={updateFatLevel}
      />
      <FatLevelOption
        optionTile="medium"
        selectedFatLevel={fatLevel}
        clickHandler={updateFatLevel}
        />
      <FatLevelOption
        optionTile="low"
        selectedFatLevel={fatLevel}
        clickHandler={updateFatLevel}
        />
    </div>
        </>
  );
};

export default FatLevelSelector;
